// For bottom description on collection pages
// Removes headers

$(document).ready(function () {
    $('#collection-bottom-description :header').each(function () {
        $('#collection-bottom-description > *').filter(function () { return $.trim(this.innerHTML) == "" }).remove();
    });
});
